// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.2);
}
.carousel__slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  background-size: cover;
  background-position: center;
  z-index: 0;
}
.carousel__slide--active {
  opacity: 1;
  z-index: 1;
}
.carousel__indicators {
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 2;
}
.carousel__indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  margin: 0 6px;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}
.carousel__indicator--active {
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/banner_image.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EAEF,8CAAA;AAAA;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kCAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;AACJ;AAEI;EACE,UAAA;EACA,UAAA;AAAN;AAIE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EACA,eAAA;AAHJ;AAKI;EACE,sBAAA;AAHN","sourcesContent":[".carousel {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 300px;\r\n  overflow: hidden;\r\n  \r\nbox-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.2);\r\n  &__slide {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    opacity: 0;\r\n    transition: opacity 1s ease-in-out;\r\n    background-size: cover;\r\n    background-position: center;\r\n    z-index: 0;\r\n    \r\n\r\n    &--active {\r\n      opacity: 1;\r\n      z-index: 1;\r\n    }\r\n  }\r\n\r\n  &__indicators {\r\n    position: absolute;\r\n    bottom: 20px;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  &__indicator {\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 50%;\r\n    border: none;\r\n    margin: 0 6px;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n    cursor: pointer;\r\n\r\n    &--active {\r\n      background-color: #fff;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
